<template>
	
	<div class="buy">
		<app-header/>
		
		<div class="container">

			<div class="row">
        
        <div class="col-sm-12">
          <div class="box-dashboard">
            <div class="bd-header">
              Total Solicitud Compras
            </div>

            <div class="bd-body expo">
              <h2>${{money(total)}}</h2>
              <p>Dinero en compras</p>
            </div>
          </div>
        </div>

        
      </div>


      <div class="box-btn">
        <div class="d-inline">
          <button type="button" v-on:click="generateCVS" class="btn btn-primary">
            CSV
          </button>
        </div>

        <div class="d-inline ml-4">
          <button type="button" v-on:click="generateAccountant" class="btn btn-primary">
            Contable
          </button>
        </div>
        
        <div class="float-right">
          <button type="button" v-b-modal.modalFilters class="btn btn-primary">
            Filtros
          </button>
        </div>
      </div>
      
      

      
      

      
      <div class="">
        
      </div>
      <div class="table table-padded">
        <b-card>
          <b-row>
            <b-col md="6" class="my-1">
              <b-form-group horizontal label="Buscador" class="mb-0">
                <b-input-group>
                  <b-form-input v-model="filter" />
                  <b-input-group-append>
                    <b-btn :disabled="!filter" @click="filter = ''">Limpiar</b-btn>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>


            <b-col md="6" class="my-1">
              <b-form-group horizontal label="Por página" class="mb-0">
                <b-form-select :options="pageOptions" v-model="perPage" />
              </b-form-group>
            </b-col>
          </b-row>

          <b-table
          
          :items="adminBuys"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          @filtered="onFiltered" class="table table-padded"
          >

          <template slot="id" slot-scope="row">
           {{row.item.id}}
         </template>
         
         <template slot="status" slot-scope="row">
           <template v-if="row.item.status == 2">
            Aprobada
          </template>
          <template v-else-if="row.item.status == 1">
            Pendiente
          </template>
          <template v-else>
            Rechazada
          </template>
        </template>

        <template slot="createdAt" slot-scope="row">
         {{row.item.createdAt.substr(0, 10)}}
       </template>

       <template slot="createdAtHour" slot-scope="row">
         {{row.item.createdAt.substr(11, 5)}}
       </template>

       <template slot="company" slot-scope="row">
         {{row.item.Company.name}}
       </template>

       <template slot="buyAt" slot-scope="row">
         {{row.item.buyAt.substr(0, 10)}}
       </template>
       
       <template slot="carrier" slot-scope="row">
         <img :src="'/providers/'+row.item.Carrier.image" class="bank">
       </template>      

      <template slot="description" slot-scope="row">
       <button v-if="row.item.description" v-b-modal.modalObservation v-on:click="viewObservation(row.item)"  type="button" class="actionBtnTable nobtn">
        <i class="material-icons" style="color: #dab51b;">assignment</i></button>
      </template>


      <template slot="amount" slot-scope="row">
        <h2 class="itemIndicator" :class="row.item.type == 'add' ? 'low' : ''">${{money(row.item.amount)}}</h2>
      </template>

      
      

      <template slot="action" slot-scope="row" >
       <template v-if="row.item.status == 1">
         
        <button v-b-modal.modalApprovePurchase class="actionBtnTable nobtn" v-on:click='currentBuy(row.item, "reject")' ><i class="material-icons" style="color: #dab51b;">clear</i></button>
        
        <button v-b-modal.modalApprovePurchase class="actionBtnTable" v-on:click='currentBuy(row.item, "approve")' ><i class="material-icons">done</i></button>

      </template>

      <button v-if="row.item.observation ||  row.item.file1" v-b-modal.modalShowBuy v-on:click="currentBuy(row.item, '')"  type="button" class="actionBtnTable nobtn">
       <i class="material-icons" style="color: #dab51b;">remove_red_eye</i></button>
     </template> 
     

   </b-table>

   <b-row>
    <b-col md="12" class="my-1 float-right">
      <b-pagination :total-rows="adminBuys.length" :per-page="perPage" v-model="currentPage" class="my-0" />
    </b-col>
  </b-row>


</b-card >

</div>

</div>

<app-footer/>



<b-modal id="modalObservation" ref="modalObservation" centered hide-footer class='box-modal' title = "Observación del cliente">
  <div>
    {{currentObservation.description}}
  </div>
</b-modal>

<b-modal id="modalApprovePurchase" ref="modalApprovePurchase" title="Aprobar" size="lg" centered hide-footer>

  <form v-on:submit.prevent="processBuy" ref="processBuyForm" name="processBuyForm" id="processBuyForm">

    <input type="hidden" :value="current.id" name="buyId">
    <input type="hidden" :value="current._prop" name="type">

    <template v-if="current._prop == 'approve'">

      <div class=""   >
        <p>Esta seguro que desea aprobar ésta compra?</p>

        <div class="row" v-for="(item, index) in items" :key="index">

          <div class="form-group col-md-6">
            <label class='control-label'>Banco</label>   

            <select class="form-control" v-on:change="selBank" :name='`items[${index}][bankId]`'>
              <option value="" disabled selected>Seleccione un banco</option>
              <option v-for="(bank, index) in banks" :key="index" :value="bank.id">{{bank.name}}</option>

            </select>
          </div>
          <div class="form-group col-md-6">
            <label class='control-label'>Valor</label>   
            <money type=""  class="form-control" :name='`items[${index}][amount]`' v-model='items[index].amount'></money>
          </div>   

        </div>

        <button type="button" class="btn btn-primary float-right" v-on:click="add"><i class="material-icons">add</i></button>


            <!-- <template v-if="curBank.id">  
                <div>
                  <img :src="'/banks/'+curBank.image" class="bankFile">
                </div>
              </template> -->
              <div class="form-group">
                <label class='col-lg-12 control-label'>Observación </label>
                <textarea type="textarea" class="form-control" name='observation'></textarea>   
              </div>

              <div class="form-group">
                <label class='col-lg-12 control-label'>Archivos</label>
                <input type="file" class="form-control" name='files' multiple>   
              </div>


            </div>
          </template>
          <template v-else>
            <p>Esta seguro que desea rechazar ésta compra?</p>

            <div class="form-group">
              <label class='col-lg-12 control-label'>Observación </label>
              <textarea type="textarea" class="form-control" name='observation'></textarea>   
            </div>
          </template>

          <button type="submit" class="btn btn-primary">Guardar</button>


        </form>
      </b-modal>

      <b-modal id="modalFilters" ref="modalFilters" centered   class='box-modal' title = "Filtrar Compras" hide-footer>
      	
      	<div class="box-modal">
         <form v-on:submit.prevent="read"> 

          <div class="form-group">
            <label class='control-label'>Fecha de la compra</label>		
            <input type="date"  class="form-control" v-model='filters.dateStart'>		
          </div>

          <div class="form-group"> 
            <label class='control-label'>Fecha de la compra</label>		
            <input type="date"  class="form-control" v-model='filters.dateEnd'>		
          </div>

          <div class="form-group">
            <label class='control-label'>Fecha de aprobación inicial</label>   
            <input type="date"  class="form-control" v-model='filters.updatedStart'>   
          </div>

          <div class="form-group"> 
            <label class='control-label'>Fecha de aprobación final</label>   
            <input type="date"  class="form-control" v-model='filters.updatedEnd'>   
          </div>

          
          <div class="form-group">
            <label class='control-label'>Código Empresa</label>
            <input type="text"  class="form-control" v-model='filters.codeCompany'>	
          </div>
         <div class="form-group">
          <label class='control-label'>Estado</label>
          <select class="form-control" v-model="filters.status">
            <option value="1" >Pendiente</option>
            <option value="2" >Aprobada</option>
            <option value="0" >Rechazada</option>
          </select> 
        </div>

        <div class="d-inline mr-4">
          <button type="submit" v-on:click="clearFilter()" class="btn btn-primary">Limpiar
          </button>
        </div>
        <div class="d-inline">
          <button type="submit" class="btn btn-primary">Filtrar</button>
        </div>
      </form>

    </div>    
    
  </b-modal>

  

  <b-modal id="modalShowBuy" hide-footer ref="modalShowBuy" centered class='box-modal' title = "Observación de la compra">

    <div class="mb-5">
      {{current.observation}}
    </div> 

    <template v-if="current.file1">
      <template  v-if="['png', 'jpg', 'bmp', 'jpeg'].indexOf( ext(current.file1) ) != -1">
        <img :src="`/files/${current.file1}`"/>
      </template>
      <template v-else>
        <a :href="`/files/${current.file1}`" target="_blank" class="btn btn-primary">Ver soporte</a>
      </template>
      

    </template>  

    <template v-if="current.file2">
      <template  v-if="['png', 'jpg', 'bmp', 'jpeg'].indexOf('.')[current.file2.split('.')[current.file2.split('.').length -1]] != -1">
        <img :src="`/files/${current.file2}`"/>
      </template>
      <template v-else>
        <a :href="`/files/${current.file2}`" target="_blank" class="btn btn-primary">Ver soporte</a>
      </template>

    </template>  

  </b-modal>

  





</div>
</template>


<script>
import { mapGetters } from "vuex";
import {
  FETCH_ADMINBUYS,
  FETCH_CARRIERS,
  FETCH_BANKS
} from "@/store/actions.type";

import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import AppPagination from "@/components/AppPagination.vue";
import { PROCESS_BUYS } from "@/store/actions.type";

export default {
  components: {
    AppHeader,
    AppFooter,
    AppPagination
  },
  data: function() {
    return {
      processForm: {
        observation: ""
      },
      curBank: {},
      data: {},
      current: {},
      currentObservation: {},
      filters: {
        dateStart: this.formatDate(Date.now()),
        dateEnd: this.formatDate(Date.now()),
        codeCompany: "",
        carrierId: ""
      },
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 20, 30, 40, 50],
      filter: null,
      fields: [
        { key: "id", label: "Id", sorteable: true },
        { key: "status", label: "Estado", sorteable: true },
        { key: "createdAt", label: "Fecha", sorteable: true },
        { key: "createdAtHour", label: "Hora", sorteable: true },
        { key: "company", label: "Compañia", sorteable: true },
        { key: "buyAt", label: "Fecha Compra", sorteable: true },
        { key: "carrier", label: "Operador", sorteable: true },
        { key: "description", label: "Descripción", sorteable: true },
        { key: "amount", label: "Valor", sorteable: true },
        { key: "action", label: "Acción", sorteable: true }
      ],
      items: [{ bankId: null, amount: 0 }],
      loading: false
    };
  },
  mounted() {
    this.$store.dispatch(FETCH_CARRIERS);
    this.read();
    this.$store.dispatch(FETCH_BANKS);
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    clearFilter() {
      (this.filters = {}), this.read();
    },

    add() {
      this.items.push({ bankId: null, amount: 0 });
    },

    read() {
      this.$refs.modalFilters.hide();
      this.$store.dispatch(FETCH_ADMINBUYS, this.filters);
      this.form = {};
    },

    processBuy() {
      if (this.loading) return;

      this.loading = true;
      let form = this.$refs.processBuyForm;
      let formData = new FormData(form);

      this.$store
        .dispatch(PROCESS_BUYS, formData)
        .then(result => {
          this.loading = false;
          this.$refs.modalApprovePurchase.hide();
          form.reset();
          this.$snotify.success(result.message);
          this.read();
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error(error.message);
        });
    },

    selBank(e) {
      var value = e.target.value;
      for (var i = this.banks.length - 1; i >= 0; i--) {
        if (this.banks[i].id == value) {
          this.curBank = this.banks[i];
          return;
        }
      }
    },

    currentBuy(current, prop) {
      this.current = current;
      this.$set(this.current, "_prop", prop);
      this.items = [{ bankId: null, amount: 0 }];
    },

    viewObservation(buy) {
      this.currentObservation = buy;
    },

    showBuy(buy) {
      this.current = buy;
      this.$refs.showBuy.show();
    },

    generateCVS() {
      var total = 0;

      var rows = [];

      this.adminBuys.map(item => {
        var status = "";
        if (item.status == 2) {
          status = "Aprobada";
        } else if (item.status == 1) {
          status = "Pendiente";
        } else {
          status = "Rechazada";
        }

        total += item.amount;

        for (var i = 0; i < item.banks.length; i++) {
          let arr = [
            item.id,
            status,
            item.createdAt.substr(0, 10),
            item.createdAt.substr(11, 5),
            item.updatedAt.substr(0, 10),
            item.updatedAt.substr(11, 5),
            item.Company.name,
            item.banks[i].bankName,
            item.banks[i].amount,
            item.buyAt.substr(0, 10),
            item.Carrier.name,
            this.replaceAll(item.description, "\n", ""),
            item.observation,
            "$" + item.amount
          ];

          rows.push(arr);
        }
      });

      rows = [
        [
          "Id",
          "Estado",
          "Fecha",
          "Hora",
          "Fecha Aprob",
          "Hora Aprob",
          "Empresa",
          "Banco",
          "Valor",
          "Fecha de Compra",
          "Operador",
          "Descripción",
          "Observacion",
          "Valor"
        ],
        ...rows,
        ["", "", "", "", "", "", "", "", "", "", "", "TOTAL:", "$" + total]
      ];

      let csvContent = "";
      rows.forEach(function(rowArray) {
        rowArray = rowArray.map(c => `"${c}"`);
        let row = rowArray.join(";");
        csvContent += row + "\r\n";
      });

      var csvData = new Blob([csvContent], { type: "text/csv" });
      var csvUrl = URL.createObjectURL(csvData);

      var hiddenElement = document.createElement("a");
      hiddenElement.href = csvUrl;
      hiddenElement.target = "_blank";
      hiddenElement.download = "Compras.csv";
      hiddenElement.click();
    },

    // generateWallet() {
    //   var total = 0;
    //   var rows = this.adminConsignments.map(item => {
    //     var statusConciliation = "";
    //     if (item.statusConciliation == 2) {
    //       statusConciliation = "Aprobada";
    //     } else if (item.status == 1) {
    //       statusConciliation = "Pendiente";
    //     } else {
    //       statusConciliation = "Proceso";
    //     }

    //     total += item.cost;
    //     return [
    //       item.id,
    //       statusConciliation,
    //       item.Company.name,
    //       item.bankName,
    //       "$" + item.cost,
    //     ];
    //   });

    //   rows = [
    //     [
    //       "Id",
    //       "Estado Conciliación",
    //       "Empresa",
    //       "Banco",
    //       "Costo Transacción"
    //     ],
    //     ...rows,
    //     ["", "", "", "", "TOTAL:", "$" + total]
    //   ];

    //   let csvContent = "";
    //   rows.forEach(function(rowArray) {
    //     let row = rowArray.join(";");
    //     csvContent += row + "\r\n";
    //   });
    //   var hiddenElement = document.createElement("a");
    //   hiddenElement.href =
    //     "data:text/csv;charset=utf-8," + encodeURI(csvContent);
    //   hiddenElement.target = "_blank";
    //   hiddenElement.download = "Cartera.csv";
    //   hiddenElement.click();
    // },

    generateAccountant() {
      var rowsX = this.adminBuys;
      var rows = [];
      var valueNull = "";
      var description = "DESEMBOLSO FACTORING.";

      rowsX = rowsX.filter(item => {
        return !!item.Carrier.nit;
      });

      var original = [];
      rowsX.map(item => {
        item.banks.map(bu => {
          var codeBank = "1110" + item.Company.codPuc;

          item.bu = bu;
          original.push(item);
          rows.push([
            codeBank,
            valueNull,
            valueNull,
            valueNull,
            valueNull,
            valueNull,
            valueNull,
            valueNull,
            valueNull,
            valueNull,
            bu.amount,
            description
          ]);
        });
      });

      var aux = [];
      for (var i = rows.length - 1; i >= 0; i--) {
        let item = original[i];
        aux.push(rows[i]);
        aux.push([
          item.Company.codPuc,
          item.Carrier.nit,
          valueNull,
          valueNull,
          valueNull,
          valueNull,
          valueNull,
          valueNull,
          valueNull,
          item.bu.amount,
          valueNull,
          description
        ]);
      }

      aux = [
        [
          "codpuc",
          "tercero",
          "ccosto",
          "sccosto",
          "docrela",
          "cuota",
          "artrela",
          "artcant",
          "base",
          "debito",
          "credito",
          "detalle",
          "ref1",
          "ref2",
          "ref3",
          "ref4",
          "libro"
        ],
        ...aux
      ];

      let csvContent = "";
      aux.forEach(function(rowArray) {
        rowArray = rowArray.map(c => `"${c}"`);
        let row = rowArray.join(";");
        csvContent += row + "\r\n";
      });
      var hiddenElement = document.createElement("a");
      hiddenElement.href =
        "data:text/csv;charset=utf-8," + encodeURI(csvContent);
      hiddenElement.target = "_blank";
      hiddenElement.download = "Contable_Compras.csv";
      hiddenElement.click();
    }
  },

  computed: {
    ...mapGetters(["adminBuys", "carriers", "banks"]),

    total: function() {
      var total = 0;
      this.adminBuys.map(row => {
        if (row.status == 2) {
          total += row.amount;
        }
      });
      return total;
    }
  }
};
</script>


<style lang="scss">
.buy {
  input {
  }

  label {
    color: #7b7b7b;
    font-weight: 900;
    font-size: 18px;
  }
  select {
    -webkit-appearance: none;
  }

  .box-modal {
    h5 {
      color: #dab51b !important;
      font-weight: 900;
      font-size: 25px;
    }
  }

  .box-filters {
    padding: 20px;
    width: 359px;
    border-radius: 20px;
    box-shadow: 1px 4px 7px rgba(0, 0, 0, 0.38);
    float: right;

    button {
      width: 100%;
    }
  }
}
</style>
